import React, {Component} from 'react';
import * as LoadingImage from '../../assets/loader.gif';
import * as SavingImage from '../../assets/savingindicator.gif';

import {Image} from "semantic-ui-react";

class Loader extends Component {
    render() {
        return (
            !this.props.contain ? <div className={"loaderContain"} style={{ position: 'fixed', left: 0, top: '0', bottom: '0', width: '100%', minHeight: '200px', zIndex: "99999" }}>
                {this.props.customText ? <div className={"loaderNoContain"} style={{width: '80%', margin: '20rem auto',borderRadius: "10px" }}>{<h1 align="center" style={{
                    margin: "auto",
                    marginTop: "3rem",
                    padding: "1rem",
                    marginBottom: "2rem",
                    display: "table",
                    borderRadius: "10px",
                    top: '40%',
                }}>
                    {this.props.customText}</h1>}
                    <Image src={!this.props.save ? LoadingImage : SavingImage} height="75px" centered style={{ paddingBottom:"2rem"}} /></div> :<Image src={!this.props.save ? LoadingImage : SavingImage} height="75px" centered style={{ top: '45%' }} /> }
            </div> : <div className={"loaderNoContain"} style={{ height: '300px', width: '80%', margin: '20px auto', marginBottom: (this.props.marginBottom ? this.props.marginBottom : null), borderRadius: "10px" }}>
                    <h1 align="center" style={{
                        margin: "auto",
                        marginTop: "3rem",
                        padding:"1rem",
                        marginBottom: "2rem",
                        display: "table",
                        borderRadius: "10px"
                    }}>
                    {this.props.customText ? this.props.customText : "Loading data... Sit tight!"}</h1>
                    <Image src={!this.props.save ? LoadingImage : SavingImage} height="75px" centered />
                    <h4 align="center" style={{ margin:"auto", marginTop:"2rem"  }}>Why not go make 1-2 pints of celery juice?🥬</h4>
                    
            </div>
        );
    }
}

export default Loader;


// WEBPACK FOOTER //
// ./src/views/universal/loader.js